import React from 'react';

import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';
import GuardedRoute from 'components/common/GuardedRoute/guardedRoute';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import NoAccess from 'components/common/NoAccess/noAccess';
import { SideMenuListProps } from 'components/common/SideMenu/SideMenu';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { Responsive } from 'components/Dashboards/responsive';
import { PhasePerformanceManageAddTemplatePage } from 'components/pages/PhasePerformanceManageAddTemplatePage';
import { PhasePerformanceManageMapProjectPage } from 'components/pages/PhasePerformanceManageMapProjectPage';
import { PhasePerformanceManagePage } from 'components/pages/PhasePerformanceManagePage';
import { PhasePerformancePage } from 'components/pages/PhasePerformancePage';
import { PortfolioOverviewPage } from 'components/pages/PortfolioOverviewPage';

export const sideMenu: SideMenuListProps[] = [
    {
        ...portfolioConfig.portfolioOverview,
        id: 'PortfolioOverview',
        muiIcon: (
            <MuiIcon icon={'business_center'} type={'outlined'} fontSize={'2.5rem'} color={'var(--text-primary)'} />
        ),
        permissions: 'PortfolioOverview',
    },
    {
        ...portfolioConfig.phasePerformance,
        id: 'PhasePerformance',
        muiIcon: <MuiIcon icon={'view_carousel'} type={'outlined'} fontSize={'2.5rem'} color={'var(--text-primary)'} />,
        permissions: 'PhasePerformance',
    },
];

export const PortfolioRoutes = () => {
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const redirect = sideMenu.find((item) => {
        return item.permissions && ability.can('view', item.permissions);
    });
    const PhasePerformanceAbility = ability.can('view', 'PhasePerformance');
    return (
        <Responsive sideMenu={sideMenu} title={'Portfolio'}>
            <Switch>
                <GuardedRoute
                    path={`${path}/${portfolioConfig.portfolioOverview.link}`}
                    component={PortfolioOverviewPage}
                    auth={ability.can('view', 'PortfolioOverview')}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageMapProject.link}`}
                    component={PhasePerformanceManageMapProjectPage}
                    auth={ability.can('view', 'PortfolioPage')}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageAddTemplate.link}`}
                    component={PhasePerformanceManageAddTemplatePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/${portfolioConfig.phasePerformanceManage.link}`}
                    component={PhasePerformanceManagePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <GuardedRoute
                    path={`${path}/${portfolioConfig.phasePerformance.link}/:templateId([0-9-]+)?`}
                    component={PhasePerformancePage}
                    auth={PhasePerformanceAbility}
                    redirect={`${path}/no-access`}
                />

                <Route exact path={`${path}/no-access`} component={NoAccess} />

                {/* default route */}
                <Route exact path={path} render={() => <Redirect to={`${path}/${redirect?.link}`} />} />
                <Route path={'*'} component={PageNotFound} />
            </Switch>
        </Responsive>
    );
};
